import { storage } from "@/firebase"


/** `contentDisposition`: "inline; filename=…" opens the file in the browser, "attachment; …" saves it straight away. */
export const UploadPhoto = async (remotePath: string, file: File | Blob, contentDisposition?: string): Promise<void> => {
  await storage().ref(remotePath).put(file, {
    contentType: file.type,
    ...(contentDisposition ? { contentDisposition } : {}),
  });
}

export const GetDownloadUrl = async (remotePath: string): Promise<string> => {
  const url = await storage().ref(remotePath).getDownloadURL();
  return url;
}

/** Public URL of an uploaded file in this environment's bucket, read under the storage rules (staging's bucket refuses plain public URLs). */
export const PublicUrl = (remotePath: string): string =>
  `https://firebasestorage.googleapis.com/v0/b/${process.env.VUE_APP_FIREBASE_STORAGE_BUCKET}/o/${encodeURIComponent(remotePath)}?alt=media`;
